import IResponse = ZoneIQCalibration.IResponse;
import ICalibrationUsesVal = ZoneIQCalibration.ICalibrationUsesVal;
import { environment } from '../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import * as _ from 'lodash';
import { BaseAPIService } from './base-api.service';
import ICalibrationUsesTypeLabel = ZoneIQCalibration.ICalibrationUsesTypeLabel;
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

const API = environment.ZONEIQ_CALIBRATION + '/v1/calibration-uses';
const API_LABELS = environment.ZONEIQ_CALIBRATION + '/v1/calibration-uses-labels';
const API_TYPES = environment.ZONEIQ_CALIBRATION + '/v1/calibration-uses-types';
const API_USES_TYPE_LABELS = environment.ZONEIQ_CALIBRATION + '/v1/calibration-uses-type-labels';

@Injectable({
    providedIn: 'root'
})
export class UsesService extends BaseAPIService {
    constructor(private readonly http: HttpClient) {
        super();
    }

    private params = new HttpParams().append('syncChanges', 'true');

    saveChanges(usesData: ICalibrationUsesVal[]) {
        if (!_.get(usesData, 'length')) {
            return;
        }
        const url = `${API}/vals`;
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const params = new HttpParams().append('syncChanges', 'true');

        return this.http.post<IResponse>(url, usesData, { headers, params });
    }

    deleteUses(usesData: number[]) {
        if (!_.get(usesData, 'length', 0)) {
            return;
        }
        const url = `${API}/vals?ids=${JSON.stringify(usesData)}`;
        return this.http.delete<IResponse>(url, { params: this.params });
    }

    addOrUpdateUsesLabels(usesData: any) {
        if (!_.get(usesData, 'length', 0)) {
            return;
        }
        const headers = new HttpHeaders().set('Content-Type', 'application/json');

        const params = new HttpParams().append('syncChanges', 'true');

        return this.http.post<IResponse>(`${API}/labels`, usesData, { headers, params });
    }

    getUsesLabelsForZoningCode(zoningCodeId: number) {
        if (!zoningCodeId) {
            return;
        }
        const params = new HttpParams().set('zoningCodeIds', zoningCodeId.toString());

        return this.http.get<IResponse>(API_LABELS, { params });
    }

    getUsesTypes() {
        return this.http.get<IResponse>(API_TYPES);
    }

    getCalibrationUsesTypeLabels(zoningCodeId: number): Observable<ICalibrationUsesTypeLabel[]> {
        if (!zoningCodeId) {
            return;
        }
        const params = new HttpParams().set('zoningCodeIds', zoningCodeId.toString());

        return this.http
            .get<IResponse>(API_USES_TYPE_LABELS, { params })
            .pipe(
                map(response => {
                    return this.getData<ICalibrationUsesTypeLabel[]>(response);
                })
            );
    }
}
